import { PairedLinesTypes } from './index.model'

export const setPairedLine = (data: any) => ({
  type: PairedLinesTypes.SET_PAIRED_LINE,
  data,
})
export const resetPairedLine = () => ({
  type: PairedLinesTypes.SET_PAIRED_LINE,
})

export const setLoader = (data: any) => ({
  type: PairedLinesTypes.SET_LOADER,
  data,
})

export const setError = (data: any) => ({
  type: PairedLinesTypes.SET_ERROR,
  data,
})

export const setAttempts = (data: any) => ({
  type: PairedLinesTypes.SET_ATTEMPTS,
  data,
})
